import ytree from "./src/ytree.vue";
// 支持按需引用
ytree.install = function (Vue) {
  Vue.component(ytree.name, ytree);
};
export default ytree;
